export const Types = {
    GET_SITE_LIST: "GET_SITE_LIST",
    OPEN_ADD_SITE_MODAL: "OPEN_ADD_SITE_MODAL",
    ADD_SITE: "ADD_SITE",
    GET_EDIT_SITE: "GET_EDIT_SITE",
    REMOVE_SITE: "REMOVE_SITE",
    CLEAR_SITE_STATES: "CLEAR_SITE_STATES",
  };
